<div class="card-details-container">
  <lib-overview-detail-card
    [title]="'MAIN_SIDEBAR.CUSTOMERS'"
    [number]="customersData.totalCount"
    [countIncrease]="customersData.countIncrease"
    [percentage]="customersData.increasePercentage"
    [iconKey]="'customers'"
    [useDetails]="true"
  />
  <lib-overview-detail-card
    [title]="'AI.BUILDINGS'"
    [number]="buildingsData.totalCount"
    [countIncrease]="buildingsData.countIncrease"
    [percentage]="buildingsData.increasePercentage"
    [iconKey]="'buildings'"
    [useDetails]="true"
  />
  <lib-overview-detail-card
    [title]="'ADVANCED_MAP.LEGEND.POLES'"
    [number]="poleSum"
    [seeBreakdownVisible]="true"
    [iconKey]="'poles'"
    (detailsClicked)="openDetailsModal('pole')"
    [useDetails]="true"
  />
  <lib-overview-detail-card
    [title]="'AI.FEEDERS'"
    [number]="feedersOverviewData.totalCount"
    [seeBreakdownVisible]="true"
    [percentage]="feedersOverviewData.increasePercentage"
    [countIncrease]="feedersOverviewData.countIncrease"
    [iconKey]="'feeders'"
    (detailsClicked)="openDetailsModal('feeder')"
    [useDetails]="true"
  />
</div>

<div class="card-details-container">
  <lib-overview-detail-card
    *ngIf="!hasCimDataIntegration"
    [title]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.DISTRIBUTION_SUBSTATIONS'"
    [number]="distributionSubstationsData.totalCount"
    [countIncrease]="distributionSubstationsData.countIncrease"
    [percentage]="distributionSubstationsData.increasePercentage"
    [iconKey]="'dts'"
    [useDetails]="true"
  />
    <lib-overview-detail-card
    *ngIf="!hasCimDataIntegration"
    [title]="'AI.INJECTION_SUBSTATIONS'"
    [number]="substationData.totalCount"
    [countIncrease]="substationData.countIncrease"
    [percentage]="substationData.increasePercentage"
    [iconKey]="'ss'"
    [useDetails]="true"
  />
  <lib-overview-detail-card
    *ngIf="!hasCimDataIntegration"
    [title]="'AI.TRANSMISSION_STATIONS'"
    [number]="tsData.totalCount"
    [countIncrease]="tsData.countIncrease"
    [percentage]="tsData.increasePercentage"
    [iconKey]="'ts'"
    [useDetails]="true"
  />
  <ng-container *ngIf="hasCimDataIntegration">
    <lib-overview-detail-card
      *ngFor="let template of substationTemplateStats"
      [title]="template.templateName"
      [number]="template.count"
      [countIncrease]="template.countIncrease"
      [percentage]="template.increasePercentage"
      [symbol]="template.symbol"
      [color]="template.color"
      [iconKey]="'dts'"
      [useDetails]="true"
    />
  </ng-container>
  <lib-overview-detail-card
    [title]="'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES'"
    [number]="devicesOverviewData.totalCount"
    [countIncrease]="devicesOverviewData.countIncrease"
    [percentage]="devicesOverviewData.increasePercentage"
    [iconKey]="'devices'"
    [useDetails]="true"
  />
</div>

<div
  class="modal fade modal-right"
  id="exampleModalCenter"
  #detailsModal
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-right" role="document">
    <div class="modal-content modal-map-details">
      <div *ngIf="selectedDetailsType === 'pole'">
        <div class="summary-header">
          <div class="summary-title">{{ 'COMMON.TOTAL' | translate }} {{ 'COMMON.POLE.PLURAL' | translate }}</div>
          <div class="summary-number">{{ poleSum | number }}</div>
        </div>
        <div class="breakdown">{{ 'COMMON.POLE.SINGLE' | translate }} {{ 'COMMON.BREAKDOWN' | translate }}</div>

        <lib-overview-detail-card
          [title]="'AI.HV_POLES'"
          [number]="hvPoleData.totalCount"
          [countIncrease]="hvPoleData.countIncrease"
          [percentage]="hvPoleData.increasePercentage"
          [iconKey]="'hv-poles'"
          [useDetails]="true"
        />
        <lib-overview-detail-card
          [title]="'AI.MV_POLES'"
          [number]="mvPoleData.totalCount"
          [countIncrease]="mvPoleData.countIncrease"
          [percentage]="mvPoleData.increasePercentage"
          [iconKey]="'mv-poles'"
          [useDetails]="true"
        />
        <lib-overview-detail-card
          [title]="'AI.LV_POLES'"
          [number]="lvPoleData.totalCount"
          [countIncrease]="lvPoleData.countIncrease"
          [percentage]="lvPoleData.increasePercentage"
          [iconKey]="'lv-poles'"
          [useDetails]="true"
        />
      </div>
      <div *ngIf="selectedDetailsType === 'feeder'">
        <div class="summary-header">
          <div class="summary-title">{{ 'COMMON.TOTAL' | translate }} {{ 'COMMON.FEEDERS' | translate }}</div>
          <div class="summary-number">{{ feederSum | number }}</div>
        </div>
        <div class="breakdown">{{ 'COMMON.FEEDER' | translate }} {{ 'COMMON.BREAKDOWN' | translate }}</div>
        <lib-overview-detail-card
          [title]="'PRIMARY_FEEDER'"
          [number]="primaryFeederDisplay.totalCount"
          [countIncrease]="primaryFeederDisplay.countIncrease"
          [percentage]="primaryFeederDisplay.increasePercentage"
          [iconKey]="'feeders'"
          [useDetails]="true"
        />
        <lib-overview-detail-card
          [title]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.MAIN_FEEDERS'"
          [number]="mainFeederDisplay.totalCount"
          [countIncrease]="mainFeederDisplay.countIncrease"
          [percentage]="mainFeederDisplay.increasePercentage"
          [iconKey]="'feeders'"
          [useDetails]="true"
        />
        <lib-overview-detail-card
          *ngIf="hasCimDataIntegration"
          [title]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.SECONDARY_FEEDERS'"
          [number]="secondaryFeederData.totalCount"
          [countIncrease]="secondaryFeederData.countIncrease"
          [percentage]="secondaryFeederData.increasePercentage"
          [iconKey]="'feeders'"
          [useDetails]="true"
        />
      </div>
      <div *ngIf="selectedDetailsType === 'network-structure'">
        <div class="summary-header">
          <div class="summary-title">{{ 'COMMON.TOTAL' | translate }} {{ 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE' | translate }}</div>
          <div class="summary-number">{{ networkStructureSum | number }}</div>
        </div>
        <div class="breakdown">{{ 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE' | translate }} {{ 'COMMON.BREAKDOWN' | translate }}</div>
        <lib-overview-detail-card
          [title]="'AI.TRANSMISSION_STATIONS'"
          [number]="tsData.totalCount"
          [countIncrease]="tsData.countIncrease"
          [percentage]="tsData.increasePercentage"
          [iconKey]="'ts'"
          [useDetails]="true"
        />
        <lib-overview-detail-card
          [title]="'AI.INJECTION_SUBSTATIONS'"
          [number]="substationData.totalCount"
          [countIncrease]="substationData.countIncrease"
          [percentage]="substationData.increasePercentage"
          [iconKey]="'ss'"
          [useDetails]="true"
        />
        <lib-overview-detail-card
          [title]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.DISTRIBUTION_SUBSTATIONS'"
          [number]="distributionSubstationsData.totalCount"
          [countIncrease]="distributionSubstationsData.countIncrease"
          [percentage]="distributionSubstationsData.increasePercentage"
          [iconKey]="'dts'"
          [useDetails]="true"
        />
      </div>

      <hr />

      <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>
